document.addEventListener('DOMContentLoaded', () => {
  const educationStages = document.querySelector('.education-stages');

  if (!educationStages) {
    return;
  }

  const mobileQuery = window.matchMedia('(max-width: 680px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const toggles = educationStages.querySelectorAll('.education-stages__track-toggle');
  const closeTimers = new WeakMap();
  const shouldAnimate = () => (
    !reducedMotionQuery.matches && document.body.dataset.accessibility !== 'true'
  );

  const setPanelState = (toggle, isOpen, animate = true) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));

    if (!panel) {
      return;
    }

    const closeTimer = closeTimers.get(panel);

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimers.delete(panel);
    }

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    if (!animate || !shouldAnimate()) {
      panel.classList.toggle('is-open', isOpen);
      panel.hidden = !isOpen;
      return;
    }

    if (isOpen) {
      panel.hidden = false;
      panel.getBoundingClientRect();
      panel.classList.add('is-open');
      return;
    }

    panel.classList.remove('is-open');

    closeTimers.set(panel, window.setTimeout(() => {
      if (toggle.getAttribute('aria-expanded') === 'false') {
        panel.hidden = true;
      }

      closeTimers.delete(panel);
    }, 300));
  };

  const applyResponsiveDefaults = () => {
    toggles.forEach((toggle) => {
      if (toggle.dataset.userToggled === 'true') {
        return;
      }

      const defaultState = mobileQuery.matches
        ? toggle.dataset.openMobile
        : toggle.dataset.openDesktop;

      setPanelState(toggle, defaultState === 'true', false);
    });
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      toggle.dataset.userToggled = 'true';
      setPanelState(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    });
  });

  applyResponsiveDefaults();

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', applyResponsiveDefaults);
  } else {
    mobileQuery.addListener(applyResponsiveDefaults);
  }
});
